jQuery( document ).ready(function() {
  jQuery(document).foundation(); 
}); 

